<template>
  <widget
    :color="color"
    icon="fa fa-phone-alt"
    :title="title"
    :value="value"
    :loading="loading"
  />
</template>

<script>
import apiDashboard from '@/apis/dashboard'

import Widget from '@/components/widget/widget8'

export default {
  props: {
    clear: Number,
    refresh: Object,
    from: String,
    to: String,
    title: String,
    direction: String
  },
  components: {
    Widget
  },
  data() {
    return {
      color:
        this.direction === 'outbound'
          ? this.$getVoiceOutboundColor[0]
          : this.$getVoiceColor[0],
      value: 0,
      loading: false
    }
  },
  watch: {
    clear: {
      handler(val) {
        if (val) this.loading = true
      }
    },
    'refresh.count': {
      immediate: true,
      handler(val) {
        this.getVoiceSession()
      }
    }
  },
  methods: {
    async getVoiceSession() {
      this.loading = true

      try {
        const obj = {
          from: this.from,
          to: this.to,
          direction: this.direction
        }
        const getVoiceSession = await apiDashboard.getVoiceSession(obj)
        this.value = getVoiceSession.total
      } catch {
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
